(function copyLink(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.FullImageViewer = global.NewHomeSource.FullImageViewer || {};

  if (!global.NewHomeSource.FullImageViewer.UrlHandler ||
    !global.NewHomeSource.FullImageViewerOpener) {
    return;
  }

  const previousCopyLink = global.NewHomeSource.FullImageViewer.CopyLink;
  const queryCopyLink = '[data-copy-link]';
  const alertCopyLink = global.document.querySelector(queryCopyLink + ' [data-alert-copied]');
  const hidden = 'hidden';
  const urlToCopyInput = global.document.querySelector('input[name="linkToCopy"]');
  const urlToCopy = urlToCopyInput.value;

  /**
   * @constructs NewHomeSource.FullImageViewer.CopyLink
   */
  function CopyLink() {
  }

  /**
* @public
* toggleCopyAlert: copy current url to clipboard and show or hidde alert.
*
* @param {MouseEvent} event with the information related to click pressed.
*/
  CopyLink.toggleCopyAlert = function toggleAlertCopied(event) {
    if (event && event.type !== 'mouseleave') {
      alertCopyLink.removeAttribute(hidden);
      navigator.clipboard.writeText(urlToCopy);
    } else {
      alertCopyLink.setAttribute(hidden, '');
    }
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.FullImageViewer.CopyLink to the previous script.
   */
  CopyLink.noConflict = function noConflict() {
    global.NewHomeSource.FullImageViewer.CopyLink = previousCopyLink;
    return CopyLink;
  };

  const eventsConfiguration = {
    copyLinkButton: {
      callbacks: [CopyLink.toggleCopyAlert],
      events: ['click', 'mouseleave'],
      elements: queryCopyLink,
    },
  };

  if (!navigator.clipboard) {
    global.document.querySelector(queryCopyLink).setAttribute(hidden, 'true');
  }

  global.NewHomeSource.Event(eventsConfiguration);
  global.NewHomeSource.FullImageViewer.CopyLink = CopyLink;
}(window));
